import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { StorageManagerService } from "../../core/services/storage-manager.service";
import { AppConfigurationService } from "../../../cemexng2components/components/app-configuration/services/ipc-app-configuration.service";

@Component({
  selector: "financial-documents-router",
  templateUrl: "./financial-documents-router.component.html",
  styleUrls: ["./financial-documents-router.component.scss"],
})
export class FinancialDocumentsRouterComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private storageManagerService: StorageManagerService,
    private router: Router,
    protected appConfigurationService: AppConfigurationService
  ) {}

  ngOnInit(): void {
    this.initializeNavigation();
  }

  private initializeNavigation(): void {
    Promise.all([this.getUserProfileAsync(), this.checkFeatureToggleAsync()])
      .then(([userProfile, isFeatureEnabled]) => {
        const userType = userProfile && userProfile.userType;
        const internalUserStaff = this.appConfigurationService.isEnabled("financial-documents.internal-users-staff");

        if (internalUserStaff || (isFeatureEnabled && userType === "C")) {
          this.router.navigate(["/invoices-payments/financial-documents/financial-documents-v2"]);
        } else {
          this.router.navigate(["/invoices-payments/financial-documents/financial-documents-v1"]);
        }
      })
      .catch((error) => {
        console.error("Error en la navegación asíncrona:", error);
      });
  }

  private getUserProfileAsync(): Promise<any> {
    return new Promise((resolve) => {
      setTimeout(() => {
        const userProfile = this.storageManagerService.user_profile;
        resolve(userProfile);
      }, 500);
    });
  }

  private checkFeatureToggleAsync(): Promise<boolean> {
    return new Promise((resolve) => {
      setTimeout(() => {
        const isFeatureEnabled = sessionStorage.getItem("country") === "GB";
        resolve(isFeatureEnabled);
      }, 500);
    });
  }
}
